module.exports = [
  { title: 'create', path: 'create' },
  { title: 'update', path: 'update' },
  { title: 'query', path: 'query' },
  { title: 'delete', path: 'delete' },
  { title: 'status', path: 'status'},
]
